__turbopack_context__.v({
  "focus__text_wrapper": "styles-module-scss-module__TGB9mW__focus__text_wrapper",
  "hero--secondary__picture": "styles-module-scss-module__TGB9mW__hero--secondary__picture",
  "homepage": "styles-module-scss-module__TGB9mW__homepage",
  "homepage__topAdvisors": "styles-module-scss-module__TGB9mW__homepage__topAdvisors",
  "main-goal": "styles-module-scss-module__TGB9mW__main-goal",
  "only-tablet": "styles-module-scss-module__TGB9mW__only-tablet",
  "questions": "styles-module-scss-module__TGB9mW__questions",
  "questions__accordion": "styles-module-scss-module__TGB9mW__questions__accordion",
  "questions__info": "styles-module-scss-module__TGB9mW__questions__info",
  "section-questions": "styles-module-scss-module__TGB9mW__section-questions",
  "tip": "styles-module-scss-module__TGB9mW__tip",
  "topAdvisors": "styles-module-scss-module__TGB9mW__topAdvisors",
  "topAdvisors__info_list": "styles-module-scss-module__TGB9mW__topAdvisors__info_list",
  "topAdvisors__info_title": "styles-module-scss-module__TGB9mW__topAdvisors__info_title",
});
